"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var environment_1 = require("../../environments/environment");
var resource_service_1 = require("../shared/resource.service");
var price_serializer_1 = require("./price.serializer");
var PriceService = /** @class */ (function (_super) {
    __extends(PriceService, _super);
    function PriceService(http) {
        var _this = _super.call(this, http, 'customprices/', new price_serializer_1.PriceSerializer()) || this;
        _this.baseUrl = environment_1.environment.serverUrl + 'customprices/';
        return _this;
    }
    return PriceService;
}(resource_service_1.ResourceService));
exports.PriceService = PriceService;
